import { render, staticRenderFns } from "./ProductSummaryChart.vue?vue&type=template&id=1d61735c&"
import script from "./ProductSummaryChart.vue?vue&type=script&lang=js&"
export * from "./ProductSummaryChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports